/**
 * Copies the specified text to the clipboard.
 *
 * @param text - The text to be copied to the clipboard.
 * @returns A promise that resolves when the text has been successfully copied to the clipboard,
 *          or rejects if an error occurs.
 */

export const copyToClipboard = (text: string): Promise<void> => {
  return navigator.clipboard
    .writeText(text)
    .then(() => {
      console.log("Text copied to clipboard");
    })
    .catch((err) => {
      alert(`Failed to copy text: ${err}`);
    });
};
